import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { QualityMeasureSurvey, QualityMeasureSurveyAnswer } from '@models/quality-measure-survey.model';

@Injectable({
  providedIn: 'root',
})
export class QualityMeasureSurveyService {
  private readonly baseUrl = `${environment.apiUrl}/OrganizationOnboarding`;

  constructor(private http: HttpClient) {}

  getSurvey(organizationId: number): Observable<QualityMeasureSurvey> {
    return this.http.get<QualityMeasureSurvey>(`${this.baseUrl}/${organizationId}`);
  }

  saveSurvey(organizationId: number, answers: QualityMeasureSurveyAnswer[]): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${organizationId}`, { answers });
  }

  exportSurvey(organizationId: number): Observable<{ blob: Blob; fileName: string }> {
    return this.http.get(`${this.baseUrl}/${organizationId}/export`, {
      responseType: 'blob',
      observe: 'response',
      headers: {
        Accept: 'application/pdf',
      },
    }).pipe(
      map((response: HttpResponse<Blob>) => {
        const disposition = response.headers.get('content-disposition');
        const match = disposition?.match(/filename="?([^";]+)"?/);
        const fileName = match?.[1] ?? `ORG_Questionnaire_Export_${organizationId}.pdf`;
        return { blob: response.body!, fileName };
      })
    );
  }
}
